import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Image } from 'react-bootstrap';
import $ from 'jquery'

import {
    LANDING_PATH,
    SIGN_UP_PATH,
    SIGN_IN_PATH,
    RESET_PASSWORD_PATH,
    CHANGE_PASSWORD_PATH,
} from '../../constants/routes';
import HeaderContainer from '../../containers/HeaderContainer';
import ContactComponent from '../../components/footer/contact/ContactComponent';
import FooterContainer from '../../containers/FooterContainer';
import ScrollToTop from '../../ScrollToTop';
// import BetaMessagingBannerComponent from '../../components/core/BetaMessagingBannerComponent/BetaMessagingBannerComponent';

import { WEB_WIDGET_URL } from '../../constants/common';

import './mainLayout.scss';

class MainLayout extends React.Component {
    changeWidget() {
        let interval = setInterval(function () {
            if (window.zE === undefined) {
                return;
            }
            clearInterval(interval);
            window.zE('webWidget', 'helpCenter:setSuggestions', { url: true });
        }, 100);
    }

    componentDidMount() {
        let url = WEB_WIDGET_URL.url;
        const script = document.createElement('script');

        script.src = url;
        script.async = true;
        script.id = 'ze-snippet';
        document.body.appendChild(script);
    }

    render() {
        this.changeWidget();
        //add the URL into the Issue Collector
        window.ATL_JQ_PAGE_PROPS = $.extend(window.ATL_JQ_PAGE_PROPS, {
            fieldValues: {
                customfield_11519: window.location.href,
            },
        });
        const { location: { pathname: path } } = this.props;
        const isLandingPage = path === LANDING_PATH;
        const isEntryPoint = [SIGN_UP_PATH, SIGN_IN_PATH, RESET_PASSWORD_PATH, CHANGE_PASSWORD_PATH].indexOf(path) > -1;
        const isLandingOrEntryPage = isLandingPage || isEntryPoint;

        const headerImageSource = isLandingPage
            ? require('./images/landing-banner.png')
            : require('./images/banner.png');

        return <div>
            {/* {showBetaMessagingBanner && <BetaMessagingBannerComponent />} */}
            <div className="Layout-component">
                <ScrollToTop>
                    <HeaderContainer isEntryPoint={isEntryPoint} />
                    {isLandingOrEntryPage && <div className="img-box">
                        <Image responsive src={headerImageSource} />
                        {!isLandingPage && <span>
                            <h1>Halo Fitness for Developers</h1>
                        </span>}
                    </div>}
                    {this.props.children}
                    {!isLandingOrEntryPage && <ContactComponent />}
                    <FooterContainer />
                </ScrollToTop>
            </div>
        </div>
    }
}

MainLayout.propTypes = {
    children: PropTypes.node.isRequired,
    location: PropTypes.object.isRequired,
    // showBetaMessagingBanner: PropTypes.bool.isRequired,
};

const mapStateToProps = ({
    session: { showBetaMessagingBanner },
}) => ({
    showBetaMessagingBanner,
});

export default withRouter(connect(mapStateToProps)(MainLayout));



// WEBPACK FOOTER //
// ./src/layouts/Main/MainLayout.js